import { conOperacion, errorSinConexion, esErrorDeRed } from './actualizacionApp.js';

const CLAVES_SESION = ['docente_token', 'docente_data', 'colegio_seleccionado', 'pais_code', 'time_zone', 'docente_colegios'];

export function cerrarSesionSiActual(storage, token, redirect) {
  if (!token || storage.getItem('docente_token') !== token) return false;
  CLAVES_SESION.forEach(key => storage.removeItem(key));
  redirect('/login');
  return true;
}

const esperarMs = ms => new Promise(resolve => setTimeout(resolve, ms));

export async function fetchConSesionDocente(url, options, { fetcher, storage, redirect, esperar = esperarMs }) {
  const token = storage.getItem('docente_token');
  const authorization = options?.headers?.Authorization;
  const metodo = String(options?.method || 'GET').toUpperCase();
  // Al volver de segundo plano Android tarda un momento en reactivar la red: una
  // consulta se reintenta una vez; una escritura no (podría haber llegado) y se
  // cuenta como operación en curso para no recargar la app en medio de ella.
  const pedir = async () => {
    try {
      return await fetcher(url, options);
    } catch (error) {
      if (!esErrorDeRed(error)) throw error;
      if (metodo !== 'GET') throw errorSinConexion();
      await esperar(1200);
      try { return await fetcher(url, options); } catch (otro) { throw esErrorDeRed(otro) ? errorSinConexion() : otro; }
    }
  };
  const response = metodo === 'GET' ? await pedir() : await conOperacion(pedir);
  if (response.status === 401 && authorization === `Bearer ${token}`) cerrarSesionSiActual(storage, token, redirect);
  return response;
}
